<div class="error-404">
    <div
        class="top-banner banner--default banner--left text-left position-relative"
    >
        <!-- Background -->
        <div class="banner__background position-relative">
            <div class="background background__image">
                <img
                    brandOptimizedImage
                    [alt]="
                        'PAGE-NOT-FOUND_BACKGROUND-MOBILE_IMAGE_ALT_TEXT'
                            | translate
                    "
                    [ngSrc]="
                        'PAGE-NOT-FOUND_BACKGROUND-MOBILE_IMAGE_URL' | translate
                    "
                    class="optimized-image position-relative"
                    fill
                    priority
                />
            </div>
        </div>

        <!-- overlay content -->
        <div class="banner__content content--overlay">
            <div class="container py-4 py-lg-0">
                <div class="row">
                    <section
                        class="col-12 col-lg-9 col-xl-7 px-2 px-sm-4 px-xl-6 py-4"
                    >
                        <h1
                            [innerHtml]="
                                'PAGE-NOT-FOUND_TITLE_TEXT' | translate
                            "
                            class="mb-0"
                        ></h1>
                    </section>
                </div>
                <div class="row">
                    <section
                        class="col-12 col-lg-9 col-xl-7 px-2 px-sm-4 px-xl-6 py-0 py-lg-6"
                    >
                        <h1
                            [innerHtml]="
                                'PAGE-NOT-FOUND_SUBTITLE_TEXT' | translate
                            "
                            class="mb-2"
                        ></h1>

                        <p
                            [innerHtml]="
                                'PAGE-NOT-FOUND_DESCRIPTION_TEXT' | translate
                            "
                            class="mb-0"
                        ></p>
                        <div class="mt-6 mb-3">
                            <a
                                [brandHref]="
                                    'PAGE-NOT-FOUND_BACK-BUTTON_URL' | translate
                                "
                                [innerHtml]="
                                    'PAGE-NOT-FOUND_BACK-BUTTON_LABEL_TEXT'
                                        | translate
                                "
                                class="btn btn-primary btn-icon btn-icon-left"
                            >
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>
